import {ftsSuggestQuery} from "../partials/suggest-query-partial-builder";
import {SIZE_VAR, TERMS_VAR} from "../variables";
import {getRelationsInfo} from "../../../utils/relation-utils";
import {trimQuery} from "../../templates/utils";
import {SearchObjectsModel} from "../../../../../types/Search";

export class AutoSuggestQueryArgumentBuilder {

  private readonly searchObjectsModel: SearchObjectsModel;

  constructor(searchObjectsModel: SearchObjectsModel) {
    this.searchObjectsModel = searchObjectsModel;
  }

  buildQuery = (): string => {

    const {relations} = getRelationsInfo(this.searchObjectsModel.objectsMap);
    const suggestQuery = ftsSuggestQuery(TERMS_VAR, relations);
    return `
      query: ${trimQuery(suggestQuery)},
      size: ${SIZE_VAR}
    `;
  };

  build(): string {
    return this.buildQuery();
  }
}
